import { type RouteObject } from 'react-router-dom';
import { safeLazy } from 'react-safe-lazy';

const OpenAgentIdentities = safeLazy(async () => import('@/pages/OpenAgentIdentities'));

export const openAgent: RouteObject = {
  path: 'open-agent',
  element: <OpenAgentIdentities />,
};
